import React from 'react'
import { withStyles } from '@material-ui/styles';
import { observer } from 'mobx-react'
import FeedItem from '../FeedItem'
import { reports } from '../../firestorter'
import authStore from '../../authStore'

const classes = {
    feed: {
        backgroundColor: '#b14d9b',
        color: 'white',
    },
};

const Feed = observer(class Feed extends React.Component {
    constructor() {
        super()
        this.state = {}
    }
    componentWillUnmount(){
        reports.query = null
    }
    componentDidMount() {
        const headerElem = document.getElementById('header');
        if (headerElem) {
            this.setState({ height: window.innerHeight - headerElem.offsetHeight })
        }
        reports.query = reports.ref.orderBy('createdOn', 'desc').limit(20);
    }
    render() {
        const { classes } = this.props;
        const currentUser = authStore.user.get()
        
        const userReports = reports.docs.map((r, i) => {
            return r.data.deleted ? null : <FeedItem report={r} currentUser={currentUser} key={i} />
        })

        const feed = this.state.height ? <div><div className={classes.feed}>{userReports}</div></div> : null
        return (<div style={{ height: `${this.state.height}px`, overflow: 'scroll' }}>{feed}</div>)
    }
})

export default withStyles(classes)(Feed);